
import { RadioChannelType } from "../../radio/data/RadioChannel";
import { APIAdresses } from "../api/APIAdress";
import { APICall } from "../api/APICall";
import { RadioInfoInput } from "../input/RadioInfoInput";
import { RadioInfoResponse } from "../response/RadioInfoResponse";
import { PHPResponse } from "../../../../library-js/php/PHPResponse";

export class RadioInfo  extends APICall<RadioInfoInput,RadioInfoResponse>
{
  static readonly ADRESS = APIAdresses.RADIO_INFO;

  constructor(){ super( RadioInfo.ADRESS ); }
  
}